export default function (athletes, registrationPeople) {
    return JSON.parse(JSON.stringify(athletes)).map(person => {
        var _a, _b;
        const regPerson = registrationPeople.find(({ personId }) => personId == person.id);
        if (!regPerson)
            return person;
        return Object.assign({}, person, {
            clubName: ((_a = regPerson.personClubOrganisation) === null || _a === void 0 ? void 0 : _a.shortName) ||
                ((_b = regPerson.personClubOrganisation) === null || _b === void 0 ? void 0 : _b.name) ||
                person.clubName,
            licenceCategoryId: regPerson.personLicenceCategoryId || person.licenceCategoryId,
            licenceCategory: regPerson.personLicenceCategory ||
                person.licenceCategory || { name: null }
        });
    });
}
